import React from 'react';
import { PropTypes } from 'prop-types';

const Header = ({ className, t }) => (
  <div className={className}>
    <h2>{t('discardReasons.title')}</h2>
  </div>
);

Header.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

Header.defaultProps = {
  className: '',
  t: (t) => t,
};

export default Header;
